module.exports = __webpack_public_path__ + "static/media/tier-1.a8c4e017.jpg";